import Box from "@mui/material/Box"

export default function ActivityTypeCapsule({
  label,
  count,
  selected = false,
  onClick,
}) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      sx={{
        all: "unset",
        boxSizing: "border-box",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        pl: 1.25,
        pr: 0.4,
        py: 0.35,
        borderRadius: "999px",
        flexShrink: 0,
        backgroundColor: selected ? "colors.brand600" : "#EEEAF6",
        color: selected ? "#FFFFFF" : "colors.gray700",
        fontWeight: 600,
        fontSize: 13,
        lineHeight: 1.2,
        "&:hover": {
          backgroundColor: selected ? "colors.brand700" : "#E4DFF0",
        },
        "&:focus-visible": {
          outline: "2px solid",
          outlineColor: "colors.brand600",
          outlineOffset: 2,
        },
      }}
    >
      <Box component="span">{label}</Box>
      <Box
        component="span"
        sx={{
          minWidth: 22,
          height: 22,
          px: 0.75,
          borderRadius: "999px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 12,
          fontWeight: 700,
          backgroundColor: selected
            ? "rgba(255, 255, 255, 0.22)"
            : "rgba(120, 108, 158, 0.22)",
          color: selected ? "#FFFFFF" : "colors.gray700",
        }}
      >
        {Number(count) || 0}
      </Box>
    </Box>
  )
}
